import { useEffect } from "react";

const NAVER_SCRIPT_ID = "naver-script";
const CONVERSION_NAVER_SCRIPT_ID = "conversion-naver-script";

export enum NaverADsType {
  PurchaseCompleted = "1",
  Join = "2",
  Cart = "3",
  Reservation = "4",
  Event = "5",
}

/**
 * 네이버 검색 광고 프리미엄 로그 분석 스크립트를 전환페이지에 적용
 *
 * 네이버 로그 분석 타입
 *
 * 1: 구매 완료 cnv('1', 가격)
 *
 * 2: 회원 가입 cnv('2', 0)
 *
 * 3: 장바구니 cnv('3', 0)
 *
 * 4: 신청/예약 cnv('4', 신청값)
 *
 * 5: 기타 이벤트 cnv('5', 0)
 *
 */
export default function useNaverADsScript(): {
  tryAppendNaverADsScript: (args: {
    type: NaverADsType;
    value: string | number;
  }) => void;
} {
  const tryAppendNaverADsScript = ({
    type,
    value,
  }: {
    type: NaverADsType;
    value: string | number;
  }): void => {
    document.querySelector(`#${CONVERSION_NAVER_SCRIPT_ID}`)?.remove();

    const script = document.createElement("script");
    script.id = CONVERSION_NAVER_SCRIPT_ID;
    script.type = "text/javascript";
    script.innerHTML = `
      var _nasa = {};
      if (window.wcs) _nasa["cnv"] = wcs.cnv("${type}", "${value}");
    `;
    document.body.append(script);
  };

  useEffect(() => {
    const script = document.createElement("script");
    script.id = NAVER_SCRIPT_ID;
    script.type = "text/javascript";
    script.src = "//wcs.naver.net/wcslog.js";
    document.body.append(script);

    return () => {
      document.querySelector(`#${NAVER_SCRIPT_ID}`)?.remove();
      document.querySelector(`#${CONVERSION_NAVER_SCRIPT_ID}`)?.remove();
    };
  }, []);

  return { tryAppendNaverADsScript };
}
